import React from 'react';
import PaymentMethods from '../../../assets/payment-methods.webp';
import Shipping from '../../../assets/shipping-DHL.webp';
import ReviewsImage from '../../../assets/reviews.webp';

const Omega3TrustRow = ({ t }) => (
  <div className="t-mt-3 t-grid t-grid-cols-1 sm:t-grid-cols-3 t-gap-4 t-rounded-xl t-bg-surface t-px-4 t-py-5">
    {[
      { image: PaymentMethods, label: t('Omega3_Trust_Payment'), imageClassName: 't-max-w-[142px]' },
      { image: Shipping, label: t('Omega3_Trust_Shipping'), imageClassName: 't-max-w-[76px]' },
      { image: ReviewsImage, label: t('Omega3_Trust_Verified'), imageClassName: 't-max-w-[108px]' },
    ].map((item) => (
      <div key={item.label} className="t-flex t-flex-col t-items-center t-gap-2.5 t-text-center">
        <img src={item.image} alt={item.label} className={`t-h-auto t-w-full ${item.imageClassName}`} />
        <span className="t-text-[14px] t-italic t-text-navy" style={{ fontFamily: 'DM Serif Display, serif' }}>
          {item.label}
        </span>
      </div>
    ))}
  </div>
);

export default Omega3TrustRow;
